import { Link } from "react-router-dom";
import { Phone, Home, BookOpen, Mail } from "lucide-react";
import { CTAButton } from "@/components/shared/CTAButton";
import { Watermark } from "@/components/shared/Watermark";
import { MotionReveal } from "@/components/shared/MotionReveal";
import { SEO } from "@/components/seo/SEO";
import { FIRM } from "@/constants/firmInfo";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you're looking for could not be found." path="/404" />
      <div className="relative min-h-[75vh] grid place-items-center px-4 text-center bg-[color:var(--navy-950)] hero-noise overflow-hidden" data-testid="not-found-page">
        <Watermark word="Lost" position="center" className="text-white" />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: "radial-gradient(900px 500px at 50% 20%, rgba(184,154,61,0.16), transparent 60%)" }}
        />
        <MotionReveal className="relative">
          <p className="font-heading text-7xl sm:text-8xl text-[color:var(--gold-400)] italic mb-4">404</p>
          <h1 className="font-heading text-2xl sm:text-3xl font-medium text-white mb-3">Page Not Found</h1>
          <p className="text-slate-300 max-w-md mx-auto mb-9">
            The page you&rsquo;re looking for doesn&rsquo;t exist or may have moved. Let&rsquo;s get you back on track.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-10">
            <Link to="/" data-testid="not-found-back-home-button">
              <CTAButton variant="brass" icon={Home}>Return Home</CTAButton>
            </Link>
            <a href={`tel:${FIRM.phoneTel}`} data-testid="not-found-call-link">
              <CTAButton variant="outline" icon={Phone}>{FIRM.phoneDisplay}</CTAButton>
            </a>
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400">
            <Link to="/insights" className="inline-flex items-center gap-1.5 hover:text-[color:var(--gold-400)] transition-colors" data-testid="not-found-insights-link">
              <BookOpen className="h-4 w-4" /> Browse Insights
            </Link>
            <Link to="/contact" className="inline-flex items-center gap-1.5 hover:text-[color:var(--gold-400)] transition-colors" data-testid="not-found-contact-link">
              <Mail className="h-4 w-4" /> Contact Us
            </Link>
          </div>
        </MotionReveal>
      </div>
    </>
  );
}
